function hasFailedTests(item) {
  return (
    item &&
    item.chocoPackage &&
    item.chocoPackage.PackageTestResultStatus != null &&
    item.chocoPackage.PackageTestResultStatus !== "Passing" &&
    item.chocoPackage.PackageTestResultStatus !== "Exempted"
  );
}

function hasFailedValidations(item) {
  return (
    item &&
    item.chocoPackage &&
    item.chocoPackage.PackageValidationResultStatus != null &&
    item.chocoPackage.PackageValidationResultStatus != "Passing" &&
    item.chocoPackage.PackageValidationResultStatus != "Exempted"
  );
}

function hasFailedVirusScan(item) {
  return (
    item &&
    item.chocoPackage &&
    item.chocoPackage.PackageScanStatus != null &&
    item.chocoPackage.PackageScanStatus !== "NotFlagged" &&
    item.chocoPackage.PackageScanStatus !== "Exempted"
  );
}

function isNotApproved(item) {
  return (
    item &&
    item.chocoPackage &&
    item.chocoPackage.IsApproved != null &&
    item.chocoPackage.PackageStatus !== "Exempted" &&
    !item.chocoPackage.IsApproved
  );
}

function hasHealthInfo(item) {
  return item.chocoPackage.IsApproved != null;
}

export default {
  isNotApproved,
  hasFailedTests,
  hasFailedValidations,
  hasFailedVirusScan,
  hasHealthInfo
};
